export default __webpack_public_path__ + "static/media/body_hawaiianbikini.66fb4c4a.png";